
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const updateBonus = createAsyncThunk(
  "updateBonus/updateBonus",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post(`/activate_user_bonus`, payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const updateBonusSlice = createSlice({
  name: "updateBonus",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateBonus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateBonus.fulfilled, (state, action) => {
          

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateBonus.rejected, (state, action) => {
       
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default updateBonusSlice.reducer;
